import React, { useEffect, useState } from 'react'
import { BlocksRenderer } from '@strapi/blocks-react-renderer'

import * as styles from './accordion.module.scss'
import { useResponsive } from '../libs/helpers'

const AccordionItem = ({ id, expandAll, question, answer }) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (expandAll) {
      setOpen(true)
    } else if (!expandAll) {
      setOpen(false)
    }
  }, [expandAll, setOpen])

  useEffect(() => {
    if (question === 'Can I become a Marine Corps physician?') {
      setOpen(true)
    }
  }, [question])

  return (
    <li className={styles['accordionItem']}>
      <button className={`${styles.question} ${open ? styles.active : styles.closed}`} onClick={() => setOpen(!open)}>
        {question}
      </button>
      <div className={`${styles.answer} ${open && styles.active}`}>
        <BlocksRenderer content={answer} />
      </div>
    </li>
  )
}

const Accordion = ({ id, accordionItem, label, slug }) => {
  const [expanded, setExpanded] = useState(false)
  const [isDesktop] = useResponsive()

  const scrollToTargetAdjusted = () => {
    if (typeof window === 'undefined') return
    var element = document.getElementById(isDesktop ? 'faqs' : 'categories')
    var headerOffset = isDesktop ? 110 : 0
    var elementPosition = element.getBoundingClientRect().top
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    })
  }

  return (
    <div className={styles['wrap']}>
      <div className={styles['questionHeader']}>
        <h3 id={slug}>{label}</h3>
        <button className={`${expanded && styles['active']}`} onClick={() => setExpanded(!expanded)}>
          {expanded ? 'Close All' : 'Expand All'}
        </button>
      </div>
      <ul className={styles['questions']}>
        {accordionItem.map((item, idx) => (
          <AccordionItem key={idx + id} id={id} expandAll={expanded} {...item} />
        ))}
      </ul>
      <button className={styles['backToTop']} onClick={() => scrollToTargetAdjusted()}>
        <span>›</span> Back to Top
      </button>
    </div>
  )
}

export default Accordion
